import { render } from "./Spacer.vue?vue&type=template&id=25157e7a"
import script from "./Spacer.vue?vue&type=script&lang=js"
export * from "./Spacer.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./Spacer.vue?vue&type=style&index=0&id=25157e7a&lang=scss&module=s"
cssModules["s"] = style0

import exportComponent from "/usr/share/nginx/production/driver/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__